export default __webpack_public_path__ + "static/media/cs.5aff3caa.jpg";